export default {
  "brand.name": "USFansSheet",
  "brand.tagline": "Spreadsheet Hub",

  "nav.spreadsheet": "Spreadsheet",
  "nav.finds": "Hallazgos",
  "nav.guides": "Guías",
  "nav.reviews": "Reseñas",
  "nav.shipping": "Envío",
  "nav.coupons": "Cupones",
  "nav.warehouse": "Almacén",
  "nav.safety": "Seguridad",
  "nav.faq": "Preguntas",
  "nav.home": "Inicio",
  "nav.buyingGuide": "Guía de compra",
  "mobile.categories": "Explorar categorías",

  "hero.badge": "Recursos actualizados 2026",
  "hero.title": "USFans Spreadsheet — Busca mejor, compra con confianza",
  "hero.subtitle": "La forma más inteligente de explorar los hallazgos de USFans. Descubre hojas organizadas, enlaces W2C, guías de producto, consejos de QC, información de envío y recursos de compra — todo en un solo lugar.",
  "hero.ctaPrimary": "usfans spreadsheet",
  "hero.ctaSecondary": "comprar ahora",
  "hero.trust": "Recursos actualizados · Guías de compra · Educación de QC · Información de envío",

  "stats.resources": "Recursos",
  "stats.categories": "Categorías",
  "stats.guides": "Guías",
  "stats.languages": "Idiomas",

  "dropdown.label": "Explorar categorías",
  "dropdown.placeholder": "Elige una categoría para explorar",

  "categories.title": "Categorías de USFans Spreadsheet",
  "categories.subtitle": "Salta directamente a cualquier categoría de la tienda principal — organizado para que compares productos más rápido.",

  "category.shoes": "Zapatos",
  "category.hoodies": "Sudaderas / Suéteres",
  "category.tshirts": "Camisetas",
  "category.jackets": "Chaquetas",
  "category.pants": "Pantalones / Shorts",
  "category.headwear": "Gorras",
  "category.sets": "Conjuntos",
  "category.underwear": "Ropa interior / Calzoncillos",
  "category.jersey": "Camisetas deportivas",
  "category.accessories": "Accesorios",
  "category.bags": "Bolsos",
  "category.belts": "Cinturones",
  "category.perfumes": "Perfumes",
  "category.other": "Otras cosas",

  "articles.title": "Guías populares de USFans Spreadsheet",
  "articles.subtitle": "Artículos originales y basados en investigación para ayudarte a entender el proceso antes de pedir.",
  "articles.readMore": "Leer guía",
  "articles.viewAll": "Ver todas las guías",

  "article.1.title": "¿Qué es el USFans Spreadsheet? Guía completa 2026",
  "article.1.excerpt": "Una explicación clara de qué es el USFans Spreadsheet, cómo funciona y cómo usarlo para investigar productos, comparar ofertas y entender el QC antes de pedir.",

  "guides.title": "Guías y recursos de USFans",
  "guides.subtitle": "Profundiza en reseñas, envío, cupones, almacén y seguridad antes de pedir.",
  "guides.learnMore": "Leer guía",
  "guides.1.title": "Reseña de USFans",
  "guides.1.desc": "Una mirada equilibrada a la experiencia de compra y qué considerar.",
  "guides.2.title": "Coste de envío de USFans",
  "guides.2.desc": "Entiende peso, líneas y destino antes de enviar.",
  "guides.3.title": "Cupón de USFans",
  "guides.3.desc": "Encuentra y verifica las últimas ofertas de cupones y descuentos.",
  "guides.4.title": "Código de descuento de USFans",
  "guides.4.desc": "Cómo funcionan los códigos y en qué fijarte.",
  "guides.5.title": "Almacén de USFans",
  "guides.5.desc": "QC, almacenamiento y consolidación explicados de forma sencilla.",
  "guides.6.title": "¿USFans es legítimo?",
  "guides.6.desc": "Comprobaciones de seguridad y señales de alerta para investigar primero.",
  "article.2.title": "Reseña de USFans 2026 – ¿Vale la pena?",
  "article.2.excerpt": "Una reseña equilibrada de la experiencia de compra de USFans: qué esperar, los pros y consideraciones, y para quién funciona mejor.",
  "article.3.title": "Guía de costes de envío de USFans 2026",
  "article.3.excerpt": "Cómo se calcula el coste de envío de USFans según peso, línea y destino, y formas prácticas de estimarlo y reducirlo.",
  "article.4.title": "Guía de cupones y códigos de USFans",
  "article.4.excerpt": "Dónde encontrar cupones y códigos de descuento de USFans, cómo verificar que están vigentes y errores comunes a evitar.",
  "article.5.title": "Guía del almacén de USFans 2026",
  "article.5.excerpt": "Cómo el almacén de USFans gestiona el QC, el almacenamiento y la consolidación de paquetes antes del envío internacional.",
  "article.6.title": "¿USFans es legítimo en 2026?",
  "article.6.excerpt": "Una guía de seguridad equilibrada sobre cómo evaluar vendedores, detectar señales de alerta e investigar antes de pedir.",
  "article.7.title": "Guía de enlaces W2C de USFans",
  "article.7.excerpt": "Qué significa W2C, cómo funcionan los enlaces W2C en la hoja y cómo usarlos con seguridad.",
  "article.8.title": "Guía de QC de USFans – Cómo leer las fotos de QC",
  "article.8.excerpt": "Aprende qué inspeccionar en las fotos de QC: costuras, etiquetas, color y proporciones, antes de que se envíe tu artículo.",
  "article.9.title": "Guía de compra de USFans 2026",
  "article.9.excerpt": "Una guía paso a paso que cubre investigación, pedido, QC, pago y envío en el orden correcto.",
  "article.10.title": "Cómo usar el USFans Spreadsheet",
  "article.10.excerpt": "Un recorrido para principiantes por las categorías y columnas de la hoja y cómo convertir hallazgos en pedidos.",
  "article.11.title": "Guía de hallazgos del USFans Spreadsheet",
  "article.11.excerpt": "Qué son los hallazgos, las categorías más populares y cómo detectar uno bueno antes de comprometerte.",

  "faq.title": "Preguntas frecuentes",
  "faq.subtitle": "Respuestas rápidas sobre el USFans Spreadsheet y cómo funciona el proceso de compra.",
  "faq.q1": "¿Qué es el USFans Spreadsheet?",
  "faq.a1": "El USFans Spreadsheet es un recurso de investigación organizado que ayuda a descubrir productos, comparar ofertas, revisar la información disponible y entender el proceso de compra antes de hacer un pedido.",
  "faq.q2": "¿USFans es legítimo?",
  "faq.a2": "Ofrecemos información equilibrada y basada en investigación para ayudarte a evaluar vendedores y ofertas por ti mismo. Verifica siempre la oferta, el vendedor y las condiciones de envío antes de comprar.",
  "faq.q3": "¿Cómo funciona USFans?",
  "faq.a3": "Normalmente funciona mediante un modelo de agente de compras o forwarder: investigas productos, envías enlaces, revisas las fotos de QC y luego organizas el envío internacional a tu país.",
  "faq.q4": "¿Cuánto cuesta el envío de USFans?",
  "faq.a4": "El coste de envío depende del peso del paquete, las dimensiones, la línea de envío y el país de destino. Consulta la guía de envío y las tarifas actuales antes de pedir, ya que las estimaciones pueden variar.",
  "faq.q5": "¿Dónde encuentro cupones de USFans?",
  "faq.a5": "La disponibilidad de cupones y descuentos cambia a menudo. Comprueba siempre las últimas ofertas verificadas y sus fechas de caducidad antes de usarlas.",

  "safety.title": "Primero investiga. Luego pide.",
  "safety.body": "Una hoja puede ayudarte a investigar productos, pero ninguna oferta garantiza la calidad, la fiabilidad del vendedor, la disponibilidad ni el resultado del envío. Verifica siempre la información actual antes de pedir.",

  "finalCta.title": "¿Listo para explorar USFans?",
  "finalCta.body": "Explora la hoja, aprende el proceso y continúa a la web principal cuando estés listo.",
  "finalCta.button": "Explorar recursos de USFans",

  "footer.resources": "Recursos",
  "footer.company": "Empresa",
  "footer.legal": "Legal",
  "footer.language": "Idioma",
  "footer.about": "Sobre nosotros",
  "footer.methodology": "Metodología",
  "footer.editorial": "Política editorial",
  "footer.contact": "Contacto",
  "footer.privacy": "Privacidad",
  "footer.terms": "Términos",
  "footer.disclaimer": "Aviso legal",
  "footer.rights": "Todos los derechos reservados.",
  "footer.disclaimerText": "La información es para fines de investigación y educación. La disponibilidad de productos, precios y condiciones de envío pueden cambiar. Verifica siempre la información actual antes de comprar.",

  "article.meta": "Guía completa 2026 sobre el USFans Spreadsheet — qué es, cómo funciona y cómo usarlo para hallazgos, enlaces W2C, QC y envío.",
  "article.backHome": "Volver al inicio",
  "article.updated": "Última actualización",
  "article.readTime": "min de lectura",
  "article.toc": "Índice",
  "article.notFound": "Artículo no encontrado",
  "article.related": "¿Quieres explorar las categorías organizadas? Vuelve a la página de inicio de USFansSheet para ver la lista completa de categorías, o continúa a la tienda principal más abajo.",
};